export enum SideIconTypeEnum {
  text = 'text',
  image = 'image',
}
